<div class="sale-profile">
  <div class="container-fluid">
  
    <div class="bg-white p-2 mt-2">
      <div class="row">
        <div class="col-md-12">
          <div class="breadcrumb-wrap ms-2 me-2">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active">
                  <a routerLink="/sales" class="cursor-pointer">All Sales</a>
                </li>
                <li aria-current="page" class="breadcrumb-item active">
                  <i class="fas fa-chevron-right me-2"></i> {{ sale?.saleName }}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div class="row sale-details ps-2 pe-2">
        <div class="col-md-6 col-sm-12">
          <div class="title-wrap d-sm-flex align-items-center">
            <div class="title-thumb">
              <img
                [src]="sale?.saleImageUrl"
                *ngIf="sale?.saleImageUrl; else placeholder"
                width="60"
              />

              <ng-template #placeholder>
                <img
                  src="assets/images/horse-no-img.jpg"
                  class="default-img"
                  width="60"
                />
              </ng-template>
            </div>
            <div class="sale-title" style="position: relative">
              <p class="light-text mb-0">
                <b>{{ sale?.location }}</b>
              </p>
              <h1>
                {{ sale?.saleName }}
                <i
                  class="fa fa-spinner fa-spin"
                  *ngIf="isSaleLoading"
                ></i>
              </h1>
              <p class="light-text mb-0">
                {{ sale?.startDate | date : "dd MMM yyyy" }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 mt-2">
          <div class="row g-0 float-end">
            <div class="col-auto" *ngIf="isUserSaleEditor">
              <a
                routerLink="sale-settings"
                class="btn btn-outline-secondary me-2"
              >
                <i class="fas fa-cog"></i>
              </a>
            </div>
            <!-- <div class="col-auto">
              <button type="button" class="btn btn-outline-secondary me-2">
                <img
                  src="assets/images/rss-feed-fill-0-wght-500-grad-0-opsz-48.png"
                  srcset="
                    assets/images/rss-feed-fill-0-wght-500-grad-0-opsz-48@2x.png 2x,
                    assets/images/rss-feed-fill-0-wght-500-grad-0-opsz-48@3x.png 3x
                  "
                  class="rss_feed_FILL0_wght500_GRAD0_opsz48"
                  width="12px"
                />
                Activity
              </button>
            </div> -->
          </div>
        </div>
      </div>

      <div class="row  mt-3">
        <div class="col mb-2">
          <!-- <button
    type="button"
    class="btn btn-outline-secondary btn-filter btn-sm ms-2 me-1"
  >
    <i class="fa fa-filter" aria-hidden="true"></i>
  </button> -->


          <button type="button"
                  *ngIf="isSalesCompany"
                  class="btn btn-outline-primary btn-sm me-1 mb-1"
                  (click)="onClickTab('submissions')"
                  [ngClass]="{ active: tab === 'submissions' }">
            Submissions ({{ saleSubmissionsCount }})
          </button>
          <button type="button"
                  *ngIf="isSalesCompany"
                  class="btn btn-outline-primary btn-sm me-1 mb-1"
                  (click)="onClickTab('requests')"
                  [ngClass]="{ active: tab === 'requests' }">
            Requests ({{ saleMemberRequestCount }})
          </button>


          <!--<button type="button"
          *ngIf="isSalesCompany"
          class="btn btn-outline-primary btn-sm me-1 mb-1"
          (click)="redirectToStats(sale)">
    Repo Analytics
  </button>-->
          <button type="button"
                  *ngIf="isSalesCompany"
                  class="btn btn-outline-primary btn-sm me-1 mb-1"
                  (click)="syncSaleHorseData(sale)">
            Sync Horses
          </button>
          <button type="button"
                  class="btn btn-outline-primary btn-sm me-1 mb-1"
                  (click)="onClickTab('horses')"
                  [ngClass]="{ active: tab === 'horses' }">
            Horses ({{ (saleHorses)?.length }})
          </button>
          <button type="button"
                  class="btn btn-outline-primary btn-sm me-1 mb-1"
                  [ngClass]="{ active: tab === 'consignors' }"
                  (click)="onClickTab('consignors')">
            Consignors ({{ allSalesConsignorsCount }})
          </button>
          <button type="button"
                  *ngIf="isSalesCompany"
                  class="btn btn-outline-primary btn-sm me-1 mb-1"
                  [ngClass]="{ active: tab === 'vets' }"
                  (click)="onClickTab('vets')">
            Vets ({{ salesVetsCount }})
          </button>

          <button type="button"
                  *ngIf="isSalesCompany"
                  class="btn btn-outline-primary btn-sm me-1 mb-1"
                  [ngClass]="{ active: tab === 'contacts' }"
                  (click)="onClickTab('contacts')">
            Contacts ({{ contactsCount }})
          </button>

        </div>
        <!--<div class="col mb-2">
          <div class="btn-group" role="group" aria-label="Basic example">
            <button type="button"
                    class="btn btn-outline-primary btn-sm rounded-first btn-first fs-13"
                    (click)="onClickTab('horses')"
                    [ngClass]="{ active: tab === 'horses' }">
              Horses ({{ (saleHorses)?.length }})
            </button>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm fs-13"
              [ngClass]="{ active: tab === 'consignors' }"
              (click)="onClickTab('consignors')"
            >
              Consignors ({{ allSalesConsignorsCount }})
            </button>
            <button
              type="button"
              *ngIf="isSalesCompany"
              class="btn btn-outline-primary btn-sm rounded-last btn-last fs-13"
              [ngClass]="{ active: tab === 'vets' }"
              (click)="onClickTab('vets')"
            >
              Vets ({{ salesVetsCount }})
            </button>
          </div>
        </div>-->
      <div class="col-auto mb-2 pe-1">
        <app-search-box placeholder="Search..."
                        (searchChange)="filterData($event)">
        </app-search-box>
      </div>
         <div class="col-auto align-self-center ps-0 mb-2"  *ngIf="tab === 'contacts'">
           <button class="btn btn-sm btn-primary h-btn-search-box" type="button" (click)="AddNewContact()">
             Add Contact
           </button>
         </div>
        <div class="col-auto ps-0 mb-2" *ngIf="tab === 'horses'">
          <div class="profile-icon custom-dropdown-menu">

            <div class="tw-dropdown-container">
              <div class="tw-dropdown">
                  <input type="checkbox" id="tw-dropdown-toggle" #dropdownToggle>

                <label type="button" for="tw-dropdown-toggle"
                        class="btn btn-outline-primary h-btn-search-box btn-sm tw-dropdown-toggle"
                        id="horse-filter"
                        style="padding-top:0.35rem;">
                  <i class="fas fa-sliders-h"></i> Filters
                </label>
                <div class="tw-dropdown-content">
                  <div class="row m-0 pb-3 pt-1">
                    <div class="col">
                      <i class="fas fa-sliders-h"></i> Filters
                    </div>
                    <div class="col-auto p-0 pe-1">
                      <label for="tw-dropdown-toggle" class="close-btn"><i class="fa fa-times"></i></label>
                    </div>
                  </div>
              
                  <div class="content">
                    <form [formGroup]="filterForm">
                      <div class="row align-self-center mb-2">
                        <label class="col-form-label col-md-3 col-5" for="book">Book</label>
                        <div class="col p-0">
                          <select class="form-select" formControlName="book" id="book" aria-label="Select Book" (change)="filterSessions()">
                            <option value="" selected>- All -</option>
                            <option *ngFor="let book of books" [ngValue]="book">{{ book }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="row align-self-center mb-2">
                        <label class="col-form-label col-md-3 col-5 mt-2" for="session">Session</label>
                        <div class="col p-0">
                          <select class="form-select mt-2" formControlName="session" id="session" aria-label="Select Session">
                            <option value="" selected>- All -</option>
                            <option *ngFor="let session of sessions" [ngValue]="session">{{ session }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="row align-self-center mb-2">
                        <label class="col-form-label col-md-3 col-5 mt-2" for="consignor">Consignor</label>
                        <div class="col p-0">
                          <select class="form-select mt-2" formControlName="consignor" id="consignor" aria-label="Select Consignor">
                            <option value="" selected>- All -</option>
                            <option *ngFor="let consignor of getConsignors()" [ngValue]="consignor">{{ consignor }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="row align-self-center mb-2">
                        <label class="col-form-label col-md-3 col-5" for="sire">Sire</label>
                        <div class="col p-0">
                          <select class="form-select mt-2" formControlName="sire" id="sire" aria-label="Select Sire">
                            <option value="" selected>- All -</option>
                            <option *ngFor="let sire of getSires()" [ngValue]="sire">{{ sire }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="row align-self-center mb-2">
                        <label class="col-form-label col-md-3 col-5 mt-2" for="dam">Dam</label>
                        <div class="col p-0">
                          <select class="form-select mt-2" formControlName="dam" id="dam" aria-label="Select Dam">
                            <option value="" selected>- All -</option>
                            <option *ngFor="let dam of getDams()" [ngValue]="dam">{{ dam }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="row align-self-center mb-2">
                        <label class="col-form-label col-md-3 col-5 mt-2" for="vet">Submitting Vet</label>
                        <div class="col p-0">
                          <select class="form-select mt-2" formControlName="vet" id="vet" aria-label="Select Vet">
                            <option value="" selected>- All -</option>
                            <option *ngFor="let vet of getSubmittedVets()" [ngValue]="vet">{{ vet }}</option>
                          </select>
                        </div>
                      </div>

                   

                      <div class="row align-self-center mb-2">
                        <label class="col-form-label col-md-3 col-5 mt-2" for="xray">X-Ray</label>
                        <div class="col p-0">
                          <mat-select class="form-select mt-2" placeholder="- All -" formControlName="xray" id="xray" aria-label="Select Xray" multiple>
                            <mat-option *ngFor="let x of getXrays()" [value]="x">{{ x }}</mat-option>
                          </mat-select>
                        </div>
                      </div>

                      <div class="row align-self-center mb-2">
                        <label class="col-form-label col-md-3 col-5 mt-2" for="scope">Scope</label>
                        <div class="col p-0">
                          <mat-select class="form-select mt-2" placeholder="- All -" formControlName="scope" id="scope" aria-label="Select Scope" multiple>
                            <mat-option *ngFor="let s of getScopes()" [value]="s">{{ s }}</mat-option>
                          </mat-select>
                        </div>
                      </div>

                      <div class="row align-self-center mb-2">
                        <label class="col-form-label col-md-3 col-5 mt-2" for="report">X-Ray Report</label>
                        <div class="col p-0">
                          <mat-select class="form-select mt-2 mb-2" placeholder="- All -" formControlName="report" id="report" aria-label="Select Report" multiple>
                            <mat-option *ngFor="let r of getReports()" [value]="r">{{ r }}</mat-option>
                          </mat-select>
                        </div>
                      </div>

                      <div class="text-right">
                        <button type="button" class="btn btn-secondary filter-rest me-2" (click)="resetFilterForm()">
                          <span class="d-md-block d-none"><i class="fa fa-sync"></i> Reset</span>
                          <span class="d-block d-md-none"><i class="fa fa-sync"></i></span>
                        </button>
                        <button type="button" class="btn btn-primary filter-search" [disabled]="!filterForm.dirty" (click)="searchHorses(); dropdownToggle.checked = false">
                            <span class="d-md-block d-none" for="tw-dropdown-toggle"><i class="fa fa-search"></i> See Results</span>
                            <span class="d-block d-md-none"><i class="fa fa-search"></i></span>
                        </button>
                      </div>
                    </form>

                    <!-- Add any other content here -->
                  </div>

                </div>
              </div>
            </div>

            <!--<div class="position-relative"
                 ngbDropdown
                 [autoClose]="false"
                 #horseFilterMenuDropdown="ngbDropdown">
              <button type="button"
                      class="btn btn-outline-primary btn-sm dropdown-toggl"
                      id="horse-filter"
                      ngbDropdownToggle>
                <i class="fas fa-sliders-h"></i> Filters
              </button>
              <div class="dropdown-menu p-0 horse-filter-panel"
                   ngbDropdownMenu
                   aria-labelledby="horse-filter">
                <div class="profile-panel-wrapper p-3">
                  <div class="profile-info">Filters</div>
       
                </div>
              </div>
            </div>-->
          </div>
        </div>
      </div>

      <div class="row mt-4 mb-2" *ngIf="isSalesCompany && (tab === 'vets' || tab === 'consignors')">
        <div class="col-md-11 col-sm-12 text-center">
          <button type="button"
                  class="btn  btn-sm ms-1 mb-1"
                  [class.btn-outline-primary]="isDisabledEmailSmsButton()"
                  [class.btn-outline-secondary]="!isDisabledEmailSmsButton()"
                  *ngIf="tab === 'vets'"
                  title="{{
        !isDisabledEmailSmsButton()
          ? 'Select one or more vets to send an email'
          : 'Send email to selected vets'
      }} "
                  style="pointer-events: auto"
                  [disabled]="!isDisabledEmailSmsButton()"
                  (click)="openSaleEmailSmsPopup(sale)">
            Email/SMS ({{ selectedVets.length }})  Vet
          </button>
          <button *ngIf="tab === 'consignors'"
                  type="button"
                  class="btn  btn-sm ms-1 mb-1"
                  [class.btn-outline-primary]="isDisabledEmailSmsConsignorButton()"
                  [class.btn-outline-secondary]="!isDisabledEmailSmsConsignorButton()"
                  [disabled]="!isDisabledEmailSmsConsignorButton()"
                  (click)="openEmailConsignorsPopup(sale)">
            Email/SMS ({{ formDataEmailConsignors?.length }}) Consignors
          </button>
        </div>
      </div>

      <app-sale-horse-list
        *ngIf="tab === 'horses'"
        [tab]="tab"
        [sale]="sale"
        [saleHorses]="saleHorses"
        [updateSaleHorses]="updateSaleHorses"
        [updateSaleHorse]="saleHorse"
        [searchTerm]="searchTerm"
        [saleSetting]="saleSetting"
        [isLoaderSaleHorses]="!(saleHorsesLoaded$ | async)"
        (openStudyFilePopup)="openStudyFileModal($event)"
        (openSaleHorseStatusPopup)="openSaleHorseStatusModel($event)"
      >
      </app-sale-horse-list>

      <app-sale-consignor-list
        *ngIf="tab === 'consignors'"
        [tab]="tab"
        [searchTerm]="searchTerm"
        [saleConsignors]="saleConsignors"
        [allSalesConsignors]="allSalesConsignors"
        [allCountries]="allCountries"
        [allSalesConsignorsCount]="allSalesConsignorsCount"
        [isLoaderSaleConsignors]="isLoaderSaleConsignors"
        [defaultSelected]="formDataEmailConsignors"
        (onCheckedSaleConsignorsEvent)="onCheckedSaleConsignorsEvent($event)"
        (onConsignorContactSaveEvent)="onConsignorContactSaveEvent()"
      >
      </app-sale-consignor-list>

      <app-sale-vet-list
        *ngIf="tab === 'vets'"
        [tab]="tab"
        [searchTerm]="searchTerm"
        [saleVets]="saleVets"
        [allSalesVets]="allSalesVets"
        [salesVetsCount]="salesVetsCount"
        [isLoaderSaleVets]="isLoaderSaleVets"
        [defaultSelected]="selectedVets"
        (vetSelectionEvent)="OnMemberSelection($event)"
        (onVetContactInfoUpdate)="OnVetContactInfoUpdate($event)"
      >
      </app-sale-vet-list>

       <app-sale-horse-repo-contact-list
       *ngIf="tab === 'contacts'"
       [tab]="tab"
       [searchTerm]="searchTerm"
       [lotOrHipText]="lotOrHipText"                                   
       [contacts]="contacts"
       [contactsCount]="contactsCount"
       (onContactEditEvent)="onContactEdit($event)"
       (onDeleteContactEvent)="deleteContact($event)"
     >
     </app-sale-horse-repo-contact-list>

      <app-sale-submissions
        *ngIf="tab === 'submissions'"
        [tab]="tab"
        [searchTerm]="searchTerm"
        [saleId]="saleId"
        [sale]="sale"
        [saleSubmissions]="saleSubmissions"
        (approveDeniedSubmissionsEvent)="approveDeniedSubmissionsEvent($event)"
        (openStudyFilePopupByHorseId)="openStudyFilePopupByHorseId($event)"
      >
      </app-sale-submissions>

      <app-sale-requests
        *ngIf="tab === 'requests'"
        [tab]="tab"
        [searchTerm]="searchTerm"
        [saleMemberRequests]="saleMemberRequests"
        [saleId]="saleId"
        (approveRequest)="onApproveRequest($event)"
        (deniedRequest)="onDeniedRequest($event)"
      >
      </app-sale-requests>
    </div>
  </div>
</div>
